import { Injectable } from '@angular/core';
import { Dictionary } from 'lodash';
import { ActionApiService } from 'src/app/Services/action-api/action-api.service';
import { StoreService } from 'src/app/Services/store';

@Injectable()
export class PagesDurationService {
	durations: Dictionary<number>;
	startTime: number;

	STORAGE_KEY_NAME = 'PagesDuration';
	ldFeatures: object;

	constructor(protected actionService: ActionApiService, protected storeService: StoreService) {
		const storageData = JSON.parse(sessionStorage.getItem(this.STORAGE_KEY_NAME));
		this.durations = storageData ? storageData : {};
	}

	addPageDuration(pageName: string, durationTime: number) {
		const lastCount = this.durations[pageName] ? this.durations[pageName] : 0;
		const newDuration = {};
		newDuration[pageName] = lastCount + durationTime;
		this.durations = { ...this.durations, ...newDuration };
		this.updateSessionStorage();
	}

	updateSessionStorage() {
		sessionStorage.setItem(this.STORAGE_KEY_NAME, JSON.stringify(this.durations));
	}

	resetDuration() {
		sessionStorage.setItem(this.STORAGE_KEY_NAME, JSON.stringify({}));
	}

	sendDurations(stage: string) {
		const globalAttr = this.storeService.getGlobalAttributes();
		if (globalAttr && !globalAttr['viewMode']) {
			const requestBody: request = {
				data: { durations: this.durations },
				info: {
					action: 'PageDuration',
					notRenderPage: false,
					conditions: '',
					elementSrc: '',
					stage: stage,
				},
				isRemoteAction: true,
			};
			this.actionService.invokeActionFetchWithoutResponse(requestBody);
		}
	}

	startDisplayTimer() {
		this.startTime = Date.now();
	}

	calculateDisplayTime(stage: string) {
		const globalAttr = this.storeService.getGlobalAttributes();
		if (globalAttr != null && !globalAttr['viewmode']) {
			this.addPageDuration(stage, Math.floor((Date.now() - this.startTime) / 1000));
		}
		this.startDisplayTimer();
	}
}
